import { isEmpty } from 'lodash-es';

import { isDev } from '@/helpers';

export const onLinkButtonClick = (urlParams, habitat) => () => {
  const { freeHabitat, callToAction, freeCallToAction } = urlParams;
  const defaultURL = `https://zoolife.tv/?utm_medium=iframe${urlParams.partner ? `-partner-${urlParams.partner}` : ''}`;
  let url = defaultURL;

  if (freeHabitat && freeCallToAction && freeHabitat === habitat._id) {
    url = freeCallToAction;
  } else if (!isEmpty(callToAction)) {
    url = callToAction;
  }

  const urlRegex = isDev() ? /^https?:\/\//i : /^https:\/\/(app\.|www\.)?zoolife\.tv($|\/|\?|#)/i;

  if (!urlRegex.test(url)) {
    url = defaultURL;
  }

  window.open(url, window.iframeContext?.linkTarget || '_blank');
};

export default onLinkButtonClick;
